import React, { Fragment } from 'react';
import { useEffect } from "react";
import PageTitle from "../../HOC/page-title";
import CardWrapper from "../../HOC/card/card";
import CardHeader from "../../components/card-header";
import "./request-details.scss";
import CustomButton from "../../components/custom-button";
import SectionTitle from "../../components/section-title";
import DetailsTable from "../../components/details-table";
import { dataEOrg,dataECity,dataEProject,dataOrg,dataBank, dataProject,dataForAccountant,dataBankForAccountant,dataProjectForAccountant,dataProjectForAccountantDone }  from "../../components/data/history-data";

let  finalData = dataOrg  ,finalDataBanking = dataBank  , FinalDataProject = dataProject  ;
const getData = () => {
  if (localStorage["type"] == 'accountant'){
    finalData = dataForAccountant;
    finalDataBanking = dataBankForAccountant;
    FinalDataProject = dataProjectForAccountant;
  }
  else if (localStorage["type"] == 'applicant'){
    finalData = dataOrg;
    finalDataBanking = dataBank;
    FinalDataProject = dataProject;
  }
  else if (localStorage["type"] == 'evalutor'){
    finalData = dataOrg;
    finalDataBanking = dataBank;
    FinalDataProject = dataProject;
  }
  else if (localStorage["type"] == 'ceo'){
    finalData = dataOrg;
    finalDataBanking = dataBank;
    FinalDataProject = dataProject;
  }
  else if (localStorage["type"] == 'chairman'){
    finalData = dataOrg;
    finalDataBanking = dataBank;
    FinalDataProject = dataProject;
  }
  else if (localStorage["type"] == 'superadmin'){
    finalData = dataOrg;
    finalDataBanking = dataBank;
    FinalDataProject = dataProject;
  }
  else {
    finalData = dataOrg;
    finalDataBanking = dataBank;
    FinalDataProject = dataProject;
  }
  
}

const ShowByTypeBtns = () => {
  if (localStorage["type"] == 'accountant') {
    return (
      <React.Fragment>
           <CustomButton
            styles={{ height: "45px", width:"200px" }}
            title="معلومات الجهة"
            // handleClick={handleSave}
          />
          <CustomButton
            styles={{ height: "45px", width:"200px" }}
            title="المعلومات البنكية"
            // handleClick={handleSave}
          />
          <CustomButton
            styles={{ height: "45px", width:"200px" }}
            title="معلومات المشروع"
            // handleClick={handleSave}
          />
          <CustomButton
          styles={{ height: "45px", width:"200px" }}
          title="التوثيق"
          // handleClick={handleSave}
        />
      </React.Fragment>
    )
  }
  else if (localStorage["type"] == 'applicant') {
    return (
      <React.Fragment>
  
          <CustomButton
            styles={{ height: "45px", width:"250px" }}
            title="معلومات المشروع"
            // handleClick={handleSave}
          />
          <CustomButton
          styles={{ height: "45px", width:"250px" }}
          title="التقرير"
          // handleClick={handleSave}
        />
      </React.Fragment>
    )
  }
  else if (localStorage["type"] == 'evalutor') {
    return (
      <React.Fragment>
           <CustomButton
            styles={{ height: "45px", width:"200px" }}
            title="معلومات الجهة"
            // handleClick={handleSave}
          />
          <CustomButton
            styles={{ height: "45px", width:"200px" }}
            title="المعلومات البنكية"
            // handleClick={handleSave}
          />
          <CustomButton
            styles={{ height: "45px", width:"200px" }}
            title="معلومات المشروع"
            // handleClick={handleSave}
          />
          <CustomButton
          styles={{ height: "45px", width:"200px" }}
          title="معايير الدعم"
          // handleClick={handleSave}
        />
      </React.Fragment>
    )
   
  }
  else if (localStorage["type"] == 'ceo') {
    return (
      <React.Fragment>
             <CustomButton
            styles={{ height: "45px", width:"200px" }}
            title="معلومات الجهة"
            // handleClick={handleSave}
          />
          <CustomButton
            styles={{ height: "45px", width:"200px" }}
            title="المعلومات البنكية"
            // handleClick={handleSave}
          />
          <CustomButton
            styles={{ height: "45px", width:"200px" }}
            title="معلومات المشروع"
            // handleClick={handleSave}
          />
          <CustomButton
          styles={{ height: "45px", width:"200px" }}
          title="التقييم والتوصية"
          // handleClick={handleSave}
        />
      </React.Fragment>
    )
   
  }
  else if (localStorage["type"] == 'chairman') {
    return (
      <React.Fragment>
         <CustomButton
              styles={{ height: "45px", width:"200px" }}
              title="معلومات الجهة"
              // handleClick={handleSave}
            />
            <CustomButton
              styles={{ height: "45px", width:"200px" }}
              title="المعلومات البنكية"
              // handleClick={handleSave}
            />
            <CustomButton
              styles={{ height: "45px", width:"200px" }}
              title="معلومات المشروع"
              // handleClick={handleSave}
            />
  
            <CustomButton
            styles={{ height: "45px", width:"200px" }}
            title=" طباعة الطلب"
            // handleClick={handleSave}
          />
      </React.Fragment>
    )
  }
  else if (localStorage["type"] == 'superadmin') {
    return (
      <React.Fragment>
         <CustomButton
              styles={{ height: "45px", width:"200px" }}
              title="معلومات الجهة"
              // handleClick={handleSave}
            />
            <CustomButton
              styles={{ height: "45px", width:"200px" }}
              title="المعلومات البنكية"
              // handleClick={handleSave}
            />
            <CustomButton
              styles={{ height: "45px", width:"200px" }}
              title="معلومات المشروع"
              // handleClick={handleSave}
            />
  
            <CustomButton
            styles={{ height: "45px", width:"200px" }}
            title=" طباعة الطلب"
            // handleClick={handleSave}
          />
      </React.Fragment>
    )
  }
  else {
   
  }

}

const ShowByTypeInfo = () => {
  if (localStorage["type"] == 'accountant') {
    return(
      <React.Fragment>
        <CardWrapper classes="header-fixed">
          <CardHeader title="تفاصيل طلب الجهة">
            <div className="buttons-container">
              {ShowByTypeBtns()}
            </div>
          </CardHeader>
          <SectionTitle title="معلومات الجهة" />
          <DetailsTable data={finalData} />
        </CardWrapper>

          <CardWrapper>
            <SectionTitle title="المعلومات البنكية" />
            <DetailsTable data={finalDataBanking} />
          </CardWrapper>


          <CardWrapper>
            <SectionTitle title="معلومات المشروع" />
            <DetailsTable data={FinalDataProject} />
          </CardWrapper>
          
          <CardWrapper>
          <SectionTitle title=" معلومات التوثيق" />
          <DetailsTable data={dataProjectForAccountantDone} />
        </CardWrapper>

      </React.Fragment>
    )
}
else if (localStorage["type"] == 'applicant') {
  return(
    <React.Fragment>
      <CardWrapper classes="header-fixed">
        <CardHeader title="تفاصيل طلب الجهة">
          <div className="buttons-container">
            {ShowByTypeBtns()}
          </div>
        </CardHeader>
        <SectionTitle title="معلومات المشروع" />
        <DetailsTable data={FinalDataProject} />
       
      </CardWrapper>
    
        <CardWrapper>
          <SectionTitle title=" تقرير المشروع" />
          <DetailsTable data={dataEProject} />
        </CardWrapper>

    </React.Fragment>
  )
}
else if (localStorage["type"] == 'evalutor') {
  return(
    <React.Fragment>
      <CardWrapper classes="header-fixed">
        <CardHeader title="تفاصيل طلب الجهة">
          <div className="buttons-container">
            {ShowByTypeBtns()}
          </div>
        </CardHeader>
        <SectionTitle title="معلومات الجهة" />
        <DetailsTable data={finalData} />
      </CardWrapper>

        <CardWrapper>
          <SectionTitle title="المعلومات البنكية" />
          <DetailsTable data={finalDataBanking} />
        </CardWrapper>


        <CardWrapper>
          <SectionTitle title="معلومات المشروع" />
          <DetailsTable data={FinalDataProject} />
        </CardWrapper>

        <CardWrapper>
          <SectionTitle title="معايير متعلقة بالجهة" />
          <DetailsTable data={dataEOrg} />
        </CardWrapper>

        <CardWrapper>
          <SectionTitle title="معايير متعلقة بالمنطقة" />
          <DetailsTable data={dataECity} />
        </CardWrapper>

        <CardWrapper>
          <SectionTitle title="معايير متعلقة بالمشروع" />
          <DetailsTable data={dataEProject} />
        </CardWrapper>

    </React.Fragment>
  )
}
else if (localStorage["type"] == 'ceo') {
  return(
    <React.Fragment>
      <CardWrapper classes="header-fixed">
        <CardHeader title="تفاصيل طلب الجهة">
          <div className="buttons-container">
            {ShowByTypeBtns()}
          </div>
        </CardHeader>
        <SectionTitle title="معلومات الجهة" />
        <DetailsTable data={finalData} />
      </CardWrapper>

        <CardWrapper>
          <SectionTitle title="المعلومات البنكية" />
          <DetailsTable data={finalDataBanking} />
        </CardWrapper>


        <CardWrapper>
          <SectionTitle title="معلومات المشروع" />
          <DetailsTable data={FinalDataProject} />
        </CardWrapper>

        <CardWrapper>
          <SectionTitle title="معايير متعلقة بالجهة" />
          <DetailsTable data={dataEOrg} />
        </CardWrapper>

        <CardWrapper>
          <SectionTitle title="معايير متعلقة بالمنطقة" />
          <DetailsTable data={dataECity} />
        </CardWrapper>

        <CardWrapper>
          <SectionTitle title="معايير متعلقة بالمشروع" />
          <DetailsTable data={dataEProject} />
        </CardWrapper>

    </React.Fragment>
  )
}
else if (localStorage["type"] == 'chairman') {
  return(
    <React.Fragment>
      <CardWrapper classes="header-fixed">
        <CardHeader title="تفاصيل طلب الجهة">
          <div className="buttons-container">
            {ShowByTypeBtns()}
          </div>
        </CardHeader>
        <SectionTitle title="معلومات الجهة" />
        <DetailsTable data={finalData} />
      </CardWrapper>

        <CardWrapper>
          <SectionTitle title="المعلومات البنكية" />
          <DetailsTable data={finalDataBanking} />
        </CardWrapper>


        <CardWrapper>
          <SectionTitle title="معلومات المشروع" />
          <DetailsTable data={FinalDataProject} />
        </CardWrapper>

        <CardWrapper>
          <SectionTitle title="معايير متعلقة بالجهة" />
          <DetailsTable data={dataEOrg} />
        </CardWrapper>

        <CardWrapper>
          <SectionTitle title="معايير متعلقة بالمنطقة" />
          <DetailsTable data={dataECity} />
        </CardWrapper>

        <CardWrapper>
          <SectionTitle title="معايير متعلقة بالمشروع" />
          <DetailsTable data={dataEProject} />
        </CardWrapper>

    </React.Fragment>
  )
}
else if (localStorage["type"] == 'superadmin') {
  return(
    <React.Fragment>
      <CardWrapper classes="header-fixed">
        <CardHeader title="تفاصيل طلب الجهة">
          <div className="buttons-container">
            {ShowByTypeBtns()}
          </div>
        </CardHeader>
        <SectionTitle title="معلومات الجهة" />
        <DetailsTable data={finalData} />
      </CardWrapper>

        <CardWrapper>
          <SectionTitle title="المعلومات البنكية" />
          <DetailsTable data={finalDataBanking} />
        </CardWrapper>


        <CardWrapper>
          <SectionTitle title="معلومات المشروع" />
          <DetailsTable data={FinalDataProject} />
        </CardWrapper>

        <CardWrapper>
          <SectionTitle title="معايير متعلقة بالجهة" />
          <DetailsTable data={dataEOrg} />
        </CardWrapper>

        <CardWrapper>
          <SectionTitle title="معايير متعلقة بالمنطقة" />
          <DetailsTable data={dataECity} />
        </CardWrapper>

        <CardWrapper>
          <SectionTitle title="معايير متعلقة بالمشروع" />
          <DetailsTable data={dataEProject} />
        </CardWrapper>

    </React.Fragment>
  )
}
else {
  return(
    <React.Fragment>
      <CardWrapper classes="header-fixed">
        <CardHeader title="تفاصيل طلب الجهة">
          <div className="buttons-container">
            {ShowByTypeBtns()}
          </div>
        </CardHeader>
        <SectionTitle title="معلومات الجهة" />
        <DetailsTable data={finalData} />
      </CardWrapper>

        <CardWrapper>
          <SectionTitle title="المعلومات البنكية" />
          <DetailsTable data={finalDataBanking} />
        </CardWrapper>


        <CardWrapper>
          <SectionTitle title="معلومات المشروع" />
          <DetailsTable data={FinalDataProject} />
        </CardWrapper>

        <CardWrapper>
          <SectionTitle title="معايير متعلقة بالجهة" />
          <DetailsTable data={dataEOrg} />
        </CardWrapper>

        <CardWrapper>
          <SectionTitle title="معايير متعلقة بالمنطقة" />
          <DetailsTable data={dataECity} />
        </CardWrapper>

        <CardWrapper>
          <SectionTitle title="معايير متعلقة بالمشروع" />
          <DetailsTable data={dataEProject} />
        </CardWrapper>

    </React.Fragment>
  )
}

  
}

const ShowByTypeEvaluationDone = () => {
  if (localStorage["type"] == 'accountant') {
  
  }
  else if (localStorage["type"] == 'applicant') {
  
  }
  else if (localStorage["type"] == 'evalutor') {
    return(
      <React.Fragment>
            <CardWrapper>
            <SectionTitle title="توصية الدارس" />
            <div className="student-recommendition">
                  <div>
                      <p> هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها التطبيق. إذا كنت تحتاج إلى عدد أكبر من الفقرات يتيح لك مولد النص العربى زيادة عدد الفقرات كما تريد، النص لن يبدو مقسما ولا يحوي أخطاء لغوية.            </p>
                  </div>

              
                  <div className="actions-container">
                
                    <CustomButton
                      title="حذف الطلب من سجل الطلبات"
                      classes="reject"
                      // handleClick={handleSave}
                    />
                  </div>
            </div>
          </CardWrapper>
      
      </React.Fragment>
    )
  }
  else if (localStorage["type"] == 'ceo') {
    return(
      <React.Fragment>
            <CardWrapper>
            <SectionTitle title="توصية الدارس" />
            <div className="student-recommendition">
                  <div>
                      <p> هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها التطبيق. إذا كنت تحتاج إلى عدد أكبر من الفقرات يتيح لك مولد النص العربى زيادة عدد الفقرات كما تريد، النص لن يبدو مقسما ولا يحوي أخطاء لغوية.            </p>
                  </div>
            </div>
          </CardWrapper>
          <CardWrapper>
            <SectionTitle title="توصية المدير التنفيذي" />
            <div className="student-recommendition">
                  <div>
                      <p> هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها التطبيق. إذا كنت تحتاج إلى عدد أكبر من الفقرات يتيح لك مولد النص العربى زيادة عدد الفقرات كما تريد، النص لن يبدو مقسما ولا يحوي أخطاء لغوية.            </p>
                  </div>

              
                  <div className="actions-container">
                
                    <CustomButton
                      title="حذف الطلب من سجل الطلبات"
                      classes="reject"
                      // handleClick={handleSave}
                    />
                  </div>
            </div>
          </CardWrapper>
      
      </React.Fragment>
    )
  }
  else if (localStorage["type"] == 'chairman') {
    return(
      <React.Fragment>
            <CardWrapper>
            <SectionTitle title="توصية الدارس" />
            <div className="student-recommendition">
                  <div>
                      <p> هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها التطبيق. إذا كنت تحتاج إلى عدد أكبر من الفقرات يتيح لك مولد النص العربى زيادة عدد الفقرات كما تريد، النص لن يبدو مقسما ولا يحوي أخطاء لغوية.            </p>
                  </div>
            </div>
          </CardWrapper>
          <CardWrapper>
            <SectionTitle title="توصية المدير التنفيذي" />
            <div className="student-recommendition">
                  <div>
                      <p> هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها التطبيق. إذا كنت تحتاج إلى عدد أكبر من الفقرات يتيح لك مولد النص العربى زيادة عدد الفقرات كما تريد، النص لن يبدو مقسما ولا يحوي أخطاء لغوية.            </p>
                  </div>

              
                  <div className="actions-container">
                
                    <CustomButton
                      title="حذف الطلب من سجل الطلبات"
                      classes="reject"
                      // handleClick={handleSave}
                    />
                  </div>
            </div>
          </CardWrapper>
      
      </React.Fragment>
    )

  }
  else if (localStorage["type"] == 'superadmin') {
    return(
      <React.Fragment>
            <CardWrapper>
            <SectionTitle title="توصية الدارس" />
            <div className="student-recommendition">
                  <div>
                      <p> هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها التطبيق. إذا كنت تحتاج إلى عدد أكبر من الفقرات يتيح لك مولد النص العربى زيادة عدد الفقرات كما تريد، النص لن يبدو مقسما ولا يحوي أخطاء لغوية.            </p>
                  </div>
            </div>
          </CardWrapper>
          <CardWrapper>
          <SectionTitle title="توصية المدير التنفيذي" />
          <div className="student-recommendition">
                <div>
                    <p> هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها التطبيق. إذا كنت تحتاج إلى عدد أكبر من الفقرات يتيح لك مولد النص العربى زيادة عدد الفقرات كما تريد، النص لن يبدو مقسما ولا يحوي أخطاء لغوية.            </p>
                </div>
          </div>
        </CardWrapper>
          
          <CardWrapper>
            <SectionTitle title="رئيس مجلس الأمناء" />
            <div className="student-recommendition">
                  <div>
                  <p>تم قبول الطلب</p>
                  </div>

              
                  <div className="actions-container">
                
                    <CustomButton
                      title="حذف الطلب من سجل الطلبات"
                      classes="reject"
                      // handleClick={handleSave}
                    />
                  </div>
            </div>
          </CardWrapper>
      
      </React.Fragment>
    )

  }
  else {
  
  }

}


const RequestDetails = ({ handleChangeKey }) => {
  useEffect(() => {
    handleChangeKey(5);
  }, []);
  getData();
  return (
    <div className="request-details-container">
      {ShowByTypeInfo()}

      {ShowByTypeEvaluationDone()}

      
    </div>
  );
};

export default PageTitle(RequestDetails);
